export var ViewIncomeDeclarationSRMapper = function (data) {
    var viewIncomeDeclarationSR = {};
    if (data) {
        viewIncomeDeclarationSR = {
            id: data.id,
            creatorId: data.creator_id,
            createdAt: data.created_at,
            creatorName: data.creator_name,
            creatorEmail: data.creator_email,
            editId: data.edit_id,
            callTypeId: data.call_type_id,
            callTypeName: data.call_type_name,
            subTypeId: data.sub_type_id,
            subTypeName: data.sub_type_name,
            clientId: data.client_id,
            boAccountNumber: data.bo_account_number,
            boName: data.bo_name,
            lob: data.lob,
            secondHolderName: data.second_holder_name,
            thirdHolderName: data.third_holder_name,
            inwardDate: data.inward_date,
            noOfBooklet: data.no_of_booklet,
            requestStatus: data.request_status,
            requestSubStatus: data.request_sub_status,
            creatorRemarks: data.creator_remarks,
            approverRemarks: data.approver_remarks,
            address: data.address,
            emailAddress: data.email_address,
            mobileNumber: data.mobile_number,
            assignedIndividualCode: data.assigned_individual_code,
            assignedIndividualName: data.assigned_individual_name,
            assignedTeamCode: data.assigned_team_code,
            assignedTeamName: data.assigned_team_name,
            assignedTo: data.assigned_to,
            accode: data.accode,
            accountName: data.account_name,
            categoryId: data.category_id,
            categoryName: data.category_name,
            panNo: data.pan_no,
            source: data.source,
            subSource: data.sub_source,
            platform: data.platform,
            referenceNumber: data.reference_number,
            description: data.description,
            clienTier: data.client_tier,
            employeeName: data.employee_name,
            creatorTeamCode: data.creator_team_code,
            creatorTeamName: data.creator_team_name,
            requestType: data.request_type,
            basisScan: data.basis_scan,
            nbfcApproval: data.nbfc_approval,
            parentId: data.parent_id,
            requestData: data.request_data,
            dPType: data.dPType,
            clientCategory: data.clientCategory,
            clientOwner: data.client_owner,
            expiryDate: data.expiry_date,
            document: data.document,
            courierDetail: data.courierDetail,
            fileName: data.file_name,
            base64Data: data.base64_data,
            brokerageChangeDetails: data.brokerageChange_Details,
            approvalLevel: data.approval_level,
            currentApprover: data.current_approver,
            validationReport: data.validationReport,
            attachments: data.attachments,
            applicableTat: data.applicable_tat,
            processDays: data.process_days,
            processTime: data.process_time,
            tat: data.tat,
            creatorSubLob: data.creator_sub_lob,
            updatedAt: data.updated_at,
            interfaceId: data.interface_id,
            dematHolding: data.demat_holding,
            clientType: data.client_type,
            serviceRequestSecondary: data.serviceRequestSecondary,
            equityAdvisorCode: data.equity_advisor_code,
            equityAdvisorPhone: data.equity_advisor_phone,
            equityAdvisorEmail: data.equity_advisor_email,
            clientOwnerEmail: data.client_owner_email,
            requestClientOwnerCode: data.request_client_owner_code,
            requestClientOwnerName: data.request_client_owner_name,
        };
    }
    return viewIncomeDeclarationSR;
};
